// extracted by mini-css-extract-plugin
module.exports = {"container":"Disclosure-module__container--KdgkE","text":"Disclosure-module__text--2J5D2","title":"Disclosure-module__title--G2U4S"};